<template>
	<div class="form-group">
		<div
			class="custom-autocomplete"
			:class="{
				'is-invalid': !!error,
				readonly: !!readonly,
				disabled: !!disabled,
				multiple: !!multiple,
			}"
			v-click-outside="hideDropdown"
		>
			<label :for="getId" v-if="!!label">{{ label }}</label>
			<div class="custom-autocomplete-selected-container">
				<button
					v-for="selected in getSelecteds()"
					v-if="!!getSelecteds()"
					class="custom-autocomplete-selected"
					@click="() => remove(selected)"
				>
					{{ getLabel(selected) }}
					<span
						class="custom-autocomplete-selected-remove"
						v-if="!!multiple && !!canEdit()"
					>
						<font-awesome-icon :icon="['far', 'times']"></font-awesome-icon>
					</span>
				</button>
			</div>
			<input
				v-if="!!showInput()"
				ref="autocompleteEl"
				type="text"
				class="form-control"
				:class="{ 'is-invalid': !!error }"
				:placeholder="placeholder"
				:disabled="disabled"
				autocomplete="off"
				:autofocus="autofocus"
				:title="label"
				:readonly="readonly"
				@click="showDropdown"
				@focus="showDropdown"
				v-model="currentInput"
			/>
			<input
				type="hidden"
				:id="getId"
				:name="name"
				:required="required"
				:disabled="disabled"
				:readonly="readonly"
				v-if="!multiple"
				v-model="internalValue"
			/>
			<select
				:id="getId"
				:name="name + '[]'"
				:required="required"
				:readonly="readonly"
				multiple
				style="display:none; height: 0; width: 0"
				v-else
			>
				<option v-for="element in internalValue" :value="element" selected></option>
			</select>
			<div
				class="custom-autocomplete-dropdown"
				v-if="!!openDropdown && getOptions().length > 0"
			>
				<button
					v-for="option in getOptions()"
					class="custom-autocomplete-item"
					@click="() => complete(option)"
				>
					{{ getLabel(option) }}
				</button>
			</div>
		</div>

		<span class="invalid-feedback" role="alert" v-if="!!error">
			<strong>{{ error }}</strong>
		</span>
	</div>
</template>

<script>
export default {
	data: () => ({
		openDropdown: false,
		selectedItems: null,
		currentInput: '',
		internalValue: null,
	}),
	props: {
		required: {
			type: Boolean,
			default: false,
			required: false,
		},
		disabled: {
			type: Boolean,
			default: false,
			required: false,
		},
		name: {
			type: String,
			default: '',
			required: false,
		},
		id: {
			type: String,
			default: '',
			required: false,
		},
		label: {
			type: String,
			default: '',
			required: false,
		},
		itemLabel: {
			type: String,
			default: 'label',
			required: false,
		},
		itemValue: {
			type: String,
			default: 'value',
			required: false,
		},
		options: {
			default: () => [],
			type: Array,
			required: true,
		},
		value: {
			type: [String, Number],
			default: '',
			required: false,
		},
		values: {
			type: Array,
			default: () => [],
			required: false,
		},
		autofocus: {
			type: Boolean,
			default: false,
			required: false,
		},
		error: {
			type: String,
			default: '',
			required: false,
		},
		multiple: {
			type: Boolean,
			default: false,
			required: false,
		},
		placeholder: {
			type: String,
			default: '',
			required: false,
		},
		readonly: {
			type: Boolean,
			default: false,
			required: false,
		},
	},
	created: function() {
		if (!!this.multiple) {
			if (!!this.values && this.values.length > 0) {
				this.selectedItems = this.values.map(t => this.getItemByValue(t))
			} else this.selectedItems = []
		} else {
			if (!!this.value || this.value === 0)
				this.selectedItems = this.getItemByValue(this.value)
			else this.selectedItems = null
		}

		this.updateValues()
	},
	computed: {
		getId: function() {
			return !!this.id ? this.id : !!this.name ? this.name : ''
		},
	},
	methods: {
		canEdit: function() {
			if (!this.readonly && !this.disabled) return true
			else return false
		},
		getValue: function(item) {
			if (!!item) return item[this.itemValue]
			else return null
		},
		getLabel: function(item) {
			if (!!item) return item[this.itemLabel]
			else return ''
		},
		getItemByValue: function(value) {
			for (var i = 0; i < this.options.length; i++) {
				if (this.getValue(this.options[i]) == value) return this.options[i]
			}

			return null
		},
		complete: function(item) {
			if (!this.canEdit()) return false

			if (!!this.multiple) {
				this.selectedItems.push(item)
			} else {
				this.selectedItems = item
			}

			this.hideDropdown()
			this.updateValues()
		},
		remove: function(item) {
			if (!this.canEdit()) return false
			if (!!this.multiple) {
				let index = false
				for (var i = 0; i < this.selectedItems.length; i++) {
					if (this.getValue(this.selectedItems[i]) == this.getValue(item)) {
						index = i
						break
					}
				}

				if (!!index || index === 0) this.selectedItems.splice(index, 1)
			} else {
				this.selectedItems = null
			}

			this.updateValues()

			let self = this
			Vue.nextTick().then(function() {
				//self.showDropdown()
				//self.$refs.autocompleteEl.focus()
			})
		},
		isValueSelected: function(value) {
			if (!!this.multiple) {
				for (var i = 0; i < this.selectedItems.length; i++) {
					if (this.getValue(this.selectedItems[i]) == value) return true
				}
			} else {
				if (this.getValue(this.selectedItems) == value) return true
			}
		},
		updateValues: function() {
			if (!!this.multiple) {
				let arr = []
				for (var i = 0; i < this.selectedItems.length; i++) {
					arr.push(this.getValue(this.selectedItems[i]))
				}

				this.internalValue = arr
			} else {
				if (!this.selectedItems) this.internalValue = null
				else this.internalValue = this.getValue(this.selectedItems)
			}
		},
		showDropdown: function() {
			this.openDropdown = true
		},
		hideDropdown: function() {
			this.openDropdown = false
			this.currentInput = ''
		},
		getSelecteds: function() {
			if (!this.selectedItems) return false

			if (!this.multiple) {
				return [this.selectedItems]
			} else {
				return this.selectedItems
			}
		},
		showitem: function(item) {
			let label = this.getLabel(item).toUpperCase()
			let value = this.getValue(item)

			if (!this.currentInput) return false

			if (!!this.isValueSelected(value)) return false

			if (label.indexOf(this.currentInput.toUpperCase()) === -1) return false

			return true
		},
		showInput: function() {
			if (!this.canEdit()) return false

			if (!!this.multiple) return true
			else {
				if (!!this.selectedItems) return false
				else return true
			}
		},
		getOptions: function() {
			let arr = []
			let count = 0
			let limit = 25

			for (var i = 0; i < this.options.length; i++) {
				let option = this.options[i]

				if (!this.showitem(option)) continue

				arr.push(option)
				count++

				if (count >= limit) break
			}

			return arr
		},
	},
}
</script>
